import { CRUDEntity } from "../abstracts/CRUDEntity";

export class SystemEmail extends CRUDEntity {
    constructor(id=null){
        super();
        this.entityClass = 'system-email';
        this.urlRoot = '/email-department';
        this.sectionRootUrl = '/email-department';
        this.id = id;
    }
}